import type { BatMetadataConfigEntry } from './common/types';
import { coreFields, genericUnitField } from './common/commonFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { msg } from '@lingui/core/macro';
import {
  cloudServiceField,
  cloudVmInstanceTypeField,
} from './common/cloudFields';

export const cloudComputeUsageMetadata = {
  displayName: msg({
    message: 'Cloud usage',
    context: 'Activity data schema name for cloud compute usage',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    cloud_region: {
      displayName: msg({
        message: 'Cloud region',
        context: `The identifier of the cloud provider's region. Examples: 'us-east-1' (AWS), 'asia-northeast2-a' (GCP).`,
      }),
      externalDescription: msg({
        message: `The identifier of the cloud provider's region. Examples: 'us-east-1' (AWS), 'asia-northeast2-a' (GCP).`,
        context: 'Cloud region',
      }),
    },
    cloud_service: cloudServiceField,
    cloud_vm_instance_type: cloudVmInstanceTypeField,
    quantity: {
      displayName: msg({
        message: 'Cloud instance hours',
        context: 'The number of instance hours for cloud compute resources.',
      }),
      externalDescription: msg({
        message: 'The number of instance hours for cloud compute resources.',
        context: 'Cloud compute usage',
      }),
    },
    unit: genericUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
